module.exports = __webpack_public_path__ + "static/media/sridhar.bf63e5af.jpg";